export default __webpack_public_path__ + "static/16-0765928c6c4d73f90d741db636bf90ee.jpg";